import './expo_page.css';
import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import bacc1 from './bacc1.png';
import bacc2 from './bacc2.png';
import bacc3 from './bacc3.png';

import vecc1 from './vecc1.png';
import vecc2 from './vecc2.png';
import vecc3 from './vecc3.png';
import vecc4 from './vecc4.png';
import vecc5 from './vecc5.png';

import reg1 from './regdb1.png';
import reg2 from './regdb2.png';

function Portfolio() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // ===================== IMMAGINI =====================

  const imagesVes = useMemo(
    () => [vecc1, vecc2, vecc3, vecc4, vecc5],
    []
  );

  const imagesPtf = useMemo(
    () => [bacc1, bacc2, bacc3],
    []
  );

  const imagesReg = useMemo(
    () => [reg1, reg2],
    []
  );

  // ===================== DESCRIZIONI =====================

  const descriptionsVes = useMemo(
    () => t('pages.portfolio.imgdescrptf1', { returnObjects: true }) || [],
    [t]
  );

  const descriptionsPtf = useMemo(
    () => t('pages.portfolio.imgdescrptf2', { returnObjects: true }) || [],
    [t]
  );

  const descriptionsReg = useMemo(
    () => t('pages.portfolio.imgdescrptf3', { returnObjects: true }) || [],
    [t]
  );

  // ===================== STATE INDIPENDENTI =====================

  const [indexVes, setIndexVes] = useState(0);
  const [indexPtf, setIndexPtf] = useState(0);
  const [indexReg, setIndexReg] = useState(0);

  // ===================== NAV =====================

  const goToVes = (idx) => setIndexVes(idx);
  const goToPtf = (idx) => setIndexPtf(idx);
  const goToReg = (idx) => setIndexReg(idx);

  // ===================== RENDER =====================

  return (
    <div className="main-wrapper">

      {/* ===================== VES ===================== */}
      <div className="tools-wrapperS2">
        <div className="sez2">

          <div className="text-im">
            <p>{t('pages.portfolio.ptf1')}</p>
          </div>

          <div className="bloc-cont">
            <div className="ic2">
              <div className="image-and-description">

                <img
                  src={imagesVes[indexVes]}
                  alt={`VES ${indexVes + 1}`}
                  className="carousel-image"
                />

                <p className="image-description">
                  {descriptionsVes[indexVes]}
                </p>

                <div className="dots">
                  {imagesVes.map((_, idx) => (
                    <span
                      key={idx}
                      className={`dot ${idx === indexVes ? 'active' : ''}`}
                      onClick={() => goToVes(idx)}
                    />
                  ))}
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      {/* ===================== PORTFOLIO ===================== */}
      <div className="tools-wrapperS1">
        <div className="sez1">

          <div className="text-im">
            <p>{t('pages.portfolio.ptf3')}</p>
          </div>

          <div className="bloc-cont">
            <div className="ic2">
              <div className="image-and-description">

                <img
                  src={imagesReg[indexReg]}
                  alt={`Portfolio ${indexReg + 1}`}
                  className="carousel-image"
                />

                <p className="image-description">
                  {descriptionsReg[indexReg]}
                </p>

                <div className="dots">
                  {imagesReg.map((_, idx) => (
                    <span
                      key={idx}
                      className={`dot ${idx === indexReg ? 'active' : ''}`}
                      onClick={() => goToReg(idx)}
                    />
                  ))}
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <div className="tools-wrapperS2">
        <div className="sez2">

          <div className="text-im">
            <p>{t('pages.portfolio.ptf2')}</p>
          </div>

          <div className="bloc-cont">
            <div className="ic2">
              <div className="image-and-description">

                <img
                  src={imagesPtf[indexPtf]}
                  alt={`Portfolio ${indexPtf + 1}`}
                  className="carousel-image"
                />

                <p className="image-description">
                  {descriptionsPtf[indexPtf]}
                </p>

                <div className="dots">
                  {imagesPtf.map((_, idx) => (
                    <span
                      key={idx}
                      className={`dot ${idx === indexPtf ? 'active' : ''}`}
                      onClick={() => goToPtf(idx)}
                    />
                  ))}
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  );
}

export default Portfolio;